<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="closeModal">
            {{ $t("com.global.add") }} {{ $t("com.discussion.discussion-profile") }}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <label class="esesja-modal__wraper__body__label">{{ $t("com.file.edit-announcement.name") }}</label>
            <section class="esesja-modal__row">
                <input
                    class="esesja-modal__wraper__body__input"
                    type="text"
                    v-model="discussionProfile.name"
                    :placecholder="$t('com.file.edit-announcement.name')"
                />
            </section>
            <ErrorMessage v-if="showDuplicateNameError" :errorMsgs="[$t('com.discussion.profile.name-unique-error')]" />

            <section class="checkbox-wrapper" @click="toggleDefaultStatus">
                <CheckBoxButtonSingleUnchecked
                    :value="1"
                    :id="'discussion-profile-default'"
                    :checked="discussionProfile.defaults"
                />
                <label class="checkbox">{{ $t("com.discussion.profile.default") }}</label>
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="closeModal">
                {{ $t("com.global.cancel") }}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave :disabled="isSaveDisabled" @save="saveDiscussionProfile">
                {{ $t("com.global.save") }}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
import DiscussionProfileService from "@/services/discussion.profile.service";
import AlertHelper from "@/helpers/alerts.helper.js";
import ErrorMessage from "@/components/BasicControls/ErrorMessage.vue";
import CheckBoxButtonSingleUnchecked from "../../../../BasicControls/CheckButtonSingleUnchecked.vue";

export default {
    name: "AddDiscussionProfile",
    components: {
        ErrorMessage,
        CheckBoxButtonSingleUnchecked
    },
    data() {
        return {
            discussionProfile: {
                name: "",
                defaults: false
            }
        };
    },
    computed: {
        availableDiscussionProfiles() {
            return this.$store.state.discussionProfileStore.discussionProfiles;
        },
        normalizedName() {
            return this.normalizeName(this.discussionProfile.name);
        },
        showDuplicateNameError() {
            return this.normalizedName.length > 0 && this.availableDiscussionProfiles.some((item) => this.normalizeName(item?.name) === this.normalizedName);
        },
        isSaveDisabled() {
            return this.discussionProfile.name.trim().length < 3 || this.showDuplicateNameError;
        }
    },
    methods: {
        normalizeName(value) {
            if (value === undefined || value === null) {
                return "";
            }

            return value.toString().trim().toLocaleLowerCase();
        },
        toggleDefaultStatus() {
            this.discussionProfile.defaults = !this.discussionProfile.defaults;
        },
        closeModal() {
            this.$store.commit("setIsShowAddDiscussionProfileStatus", false);
        },
        async saveDiscussionProfile() {
            if (this.showDuplicateNameError) {
                return;
            }

            try {
                this.$store.commit("showLoader");

                await DiscussionProfileService.Create({
                    name: this.discussionProfile.name.trim(),
                    defaults: this.discussionProfile.defaults
                });

                this.closeModal();
            } catch (e) {
                if (e.response !== undefined) {
                    const t = this.$swal.mixin(AlertHelper.errorToastElement());
                    t.fire(
                        AlertHelper.errorToastAlert(
                            this.$t("com.global.default-save-error"),
                            this.$t("com.global.error")
                        )
                    );
                }
            } finally {
                this.$store.commit("hideLoader");
            }
        }
    }
};
</script>
<style lang="scss">
.checkbox {
    font-weight: normal;
    font-size: 16px;
    line-height: 144%;
    color: #333956;
    margin-left: 12px;
    margin-bottom: 0px;
    padding-left: 24px;
    z-index: 0;
    cursor: pointer;
}

.checkbox-wrapper {
    display: flex;
    padding: 5px;
    float: left;
}
</style>
